import { Center } from '../../../lib/types/models/center/center'
import { CenterProperties } from '../../../lib/types/models/center/properties.center'
import OlCenterWeeklyPlanner, {
  OlCenterWeeklyPlannerProps,
  PlannerHandle
} from '../ol-common/ol-center-program/ol-center-weekly-planner/ol-center-weekly-planner'

type CenterCalendarProps = Omit<
  OlCenterWeeklyPlannerProps,
  'centerId' | 'startDate' | 'endDate' | 'centerActivityStatus'
>

type Props = CenterCalendarProps & {
  center?: Pick<Center, 'id' | 'activitiesStatus' | 'startDate' | 'endDate'>
  plannerRef?: React.RefObject<PlannerHandle>
}

const CenterProgramsAndActivitiesPlanner = ({ center, plannerRef, ...props }: Props) => {
  const dates = center ? CenterProperties.getDates(center) : undefined
  const startDate = dates?.departureDate
  const endDate = dates?.returnDate

  if (!startDate || !endDate || !center) return null

  return (
    <OlCenterWeeklyPlanner
      {...props}
      ref={plannerRef}
      startDate={startDate}
      endDate={endDate}
      centerId={center.id}
      centerActivityStatus={center.activitiesStatus}
    />
  )
}

export default CenterProgramsAndActivitiesPlanner
